import { MAX_LEASE_PERIOD_MONTHS } from 'base';

export const DEP_INIT_MPL = MAX_LEASE_PERIOD_MONTHS;
